import React from "react";
import "./bread-crumb-file.css";

function BreadcrumbFile({ path, onClick, onCollapsed }) {
    return (
        <div className="breadcrumb-file">
            { hp.store.perms.canEdit ? 
                <button
                    type="button"
                    className="btn btn-default btn-circular mr-2"
                    onClick={onCollapsed}
                    aria-label="Collapse"
                >
                    <em className="la la-bars"></em>
                </button>
                : null
            }
            
            {path.map((folder, index) => (
                <React.Fragment key={folder.alias}>
                    <span className="breadcrumb-item" onClick={() => onClick(folder)}>
                        {folder.name}
                    </span>
                    {index < path.length - 1 ? 
                        <span className="breadcrumb-item-icon">
                            <em className="la la-angle-right"></em>
                        </span> 
                        : null
                    }
                    
                </React.Fragment>
            ))}
        </div>
    );
}

export default BreadcrumbFile;
